import { useEffect, useRef, useState } from 'react';

import { Descendant } from 'slate';

interface UseEditorFormulaOptions {
    initialFormula: Descendant[];
    reinitializeMessageContent: number | undefined;
}

export function useEditorFormula({
    initialFormula,
    reinitializeMessageContent,
}: UseEditorFormulaOptions) {
    const [formula, setFormula] = useState(initialFormula);

    // Always keep a current reference to initialFormula so the reinitialize
    // effect below can read the latest value without taking it as a dependency.
    // This prevents a flash of default-language content that would occur when
    // initialFormula temporarily reverts to the base formula while a new
    // language's MessageContent is being fetched.
    const initialFormulaRef = useRef(initialFormula);
    useEffect(() => {
        initialFormulaRef.current = initialFormula;
    });

    useEffect(() => {
        if (reinitializeMessageContent) {
            setFormula(initialFormulaRef.current);
        }
    }, [reinitializeMessageContent]);

    return { formula, setFormula };
}
